import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

export const ClassDetailsTime = ({ schedule }) => {
  const classStartTime = schedule.starttime * 1000;
  const classEndTime = schedule.endtime * 1000;

  return (
    <span>
      <FormattedDate weekday="short" value={classStartTime} />
      ,&nbsp;
      <FormattedDate day="numeric" month="short" value={classStartTime} />
      &nbsp;&middot;&nbsp;
      <FormattedDate hour="numeric" minute="numeric" value={classStartTime} />
      &nbsp;&ndash;&nbsp;
      <FormattedDate hour="numeric" minute="numeric" value={classEndTime} />
    </span>
  );
};

ClassDetailsTime.propTypes = {
  schedule: PropTypes.object.isRequired,
};
